import React from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import { MapDisplayContainer } from './style';
import { useTranslation } from 'react-i18next';

// Fix for default marker icon
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

const MapDisplay = ({ latitude, longitude, locationName, district, postalCode }) => {
  const { t } = useTranslation();
  
  if (!latitude || !longitude) {
    return null;
  }

  const position = [latitude, longitude];

  return (
    <MapDisplayContainer>
      <h3>📍 {t('location_title')}</h3>
      <MapContainer
        center={position}
        zoom={14}
        style={{ height: '350px', width: '100%', borderRadius: '12px' }}
        scrollWheelZoom={false}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <Marker position={position}>
          <Popup>
            {locationName && <div><strong>{locationName}</strong></div>}
            {district && <div>{district}</div>}
            {postalCode && <div>CP: {postalCode}</div>}
          </Popup>
        </Marker>
      </MapContainer>
      <div className="location-info">
        {district && <span className="location-detail">📌 {district}</span>}
        {postalCode && <span className="location-detail">📮 {postalCode}</span>}
      </div>
    </MapDisplayContainer>
  );
};

export default MapDisplay;
